import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { IBreadCrumb } from './breadcrumb.interface';
import { filter, distinctUntilChanged } from 'rxjs/operators';

@Component({
	selector: 'app-breadcrumbs',
	templateUrl: './breadcrumbs.component.html',
	styleUrls: ['./breadcrumbs.component.scss'],
})
export class BreadcrumbsComponent implements OnInit {
	public breadcrumbs: IBreadCrumb[];

	constructor(private router: Router, private activatedRoute: ActivatedRoute) {
		this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
	}

	ngOnInit(): void {
		this.router.events
			.pipe(
				filter((event) => event instanceof NavigationEnd),
				distinctUntilChanged()
			)
			.subscribe(() => {
				this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root);
			});
	}

	buildBreadCrumb(
		route: ActivatedRoute,
		url: string = '',
		breadcrumbs: IBreadCrumb[] = []
	): IBreadCrumb[] {
		const label =
			route.routeConfig && route.routeConfig.data
				? route.routeConfig.data.breadcrumb
				: '';
		const path =
			route.routeConfig && route.routeConfig.data ? route.routeConfig.path : '';

		const nextUrl = path ? `${url}/${path}` : url;

		const breadcrumb: IBreadCrumb = {
			label,
			url: nextUrl,
		};

		const newBreadcrumbs = breadcrumb.label
			? [...breadcrumbs, breadcrumb]
			: [...breadcrumbs];
		if (route.firstChild) {
			return this.buildBreadCrumb(route.firstChild, nextUrl, newBreadcrumbs);
		}
		return newBreadcrumbs;
	}
}
